import React from 'react';
import PropTypes from 'prop-types';
import { DropTarget as reactDropTarget } from 'react-dnd';

import DnDItemTypes from '../common/DynamicDnD/DnDItemTypes';
import { FLEX_STUDY_TAG } from '../../constants';
import * as urls from '../../actions/urlTypes';

const dropTarget = {
  canDrop: () => true,

  drop(props, monitor) {
    props.handleTargetDrop(monitor.getItem(), props.gridType);
  },
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  };
}

const DraggableToolPaletteHeader = props => {
  const {
    renderLength,
    toggleNo,
    title,
    dataGridItems,
    gridType,
    icon,
    study,
    standardBaseCount,
    targetCountFlag,
  } = props;
  return props.connectDropTarget(
    <label
      className={`accordion__trigger tool_img ${icon}`}
      htmlFor={toggleNo}
      title={title}
    >
      {title}
      <span className="countNum">
        {(gridType === 'BasesDataGrid' ? renderLength(dataGridItems) + standardBaseCount : renderLength(dataGridItems)) +
          ((gridType === 'BasesDataGrid' || gridType === 'DataHaulBasesDataGrid') &&
          study &&
          !study.toLowerCase().includes(FLEX_STUDY_TAG)
            ? 1
            : 0)}{targetCountFlag ? `/${urls.MME_TARGET_COUNT}` : ''}
      </span>
    </label>,
  );
};

DraggableToolPaletteHeader.propTypes = {
  dataGridItems: PropTypes.arrayOf(PropTypes.shape({})),
  icon: PropTypes.string,
  gridType: PropTypes.string,
  renderLength: PropTypes.func,
  toggleNo: PropTypes.string,
  title: PropTypes.string,
  standardBaseCount: PropTypes.number,
  connectDropTarget: PropTypes.func,
};

export default reactDropTarget([DnDItemTypes.DnD_ITEM_TYPE_5], dropTarget, collect)(
  DraggableToolPaletteHeader,
);
